import { Abacus } from "core/Abacus.Core";

export class URI {
	constructor(uriString){
		this.uriString = uriString;
		this.uri = this.parse(uriString);
	}
	parse(uri){
		var questionMarkSplit = uri.split("?");
		var url = questionMarkSplit[0];
		var parametersString = questionMarkSplit[1];
		var parameters = JSON.parse('{"' + parametersString.replace(/&/g, '","').replace(/=/g,'":"') + '"}',
			function(key, value) { return key==="" ? value:decodeURIComponent(value) });
		return {
			url,
			parameters
		}
	}
	setData(param, value){
		this.uri.parameters[param] = value;
	}
	toString(){
		return this.uri.url + "?" + this.parametersToString();
	}
	parametersToString(){
		return Object.keys(this.uri.parameters)
			.map(key => ({ key: key, value: this.uri.parameters[key]}))
			.reduce((prev, param) => {
				let paramString = param.key + "=" + param.value;
				if(!prev) {
					return paramString;
				} else {
					return prev + "&" + paramString;
				}
			}, "");
	}
}


// WEBPACK FOOTER //
// ./Javascript/core/classes/uri.class.js